import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import {
  Accordion,
  AccordionRow,
  Icon,
  Divider,
  CaptionText,
} from '@paypalcorp/pp-react';
import { localsMessages, getCurrencySymbol } from '../utility/getTemplateData';
import {
  getCurrencyParts,
  formatCurrencyAsString,
  formatPercentage,
} from '../utility/formator';
import { sanitize } from '../utility/domUtils';

import { trackLinkClick } from '../fpti/fpti';
import { LINK_NAME } from '../fpti/fptiConstants';

let messages = localsMessages('common/offerdetail');

const styles = StyleSheet.create({
  offerWrapper: {
    paddingBottom: '20px',
    maxWidth: 415,
    margin: 'auto',
  },
  success: {
    paddingBottom: '8px',
  },
  accordionWrapper: {
    marginRight: 0,
    marginLeft: 0,
    backgroundColor: '#f5fbfe',
    backgroundClip: 'content-box',
  },
  offerDivider: {
    borderColor: '#BFDBEE',
    margin: 0,
  },
  offerHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    wordBreak: 'keep-all',
  },
  messageFrom: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  description: {
    paddingBottom: '10px',
  },
});

function formatOfferTextAmount(value, currencyCode, type = 'MONETARY') {
  const isAmtPercent = type === 'PERCENTAGE';
  const formattedValue = (value / 100).toFixed(2);
  const amountOpts = { currency: currencyCode, value: formattedValue };

  return isAmtPercent
    ? formatPercentage(formattedValue)
    : formatCurrencyAsString(amountOpts);
}

class OfferDetail extends React.Component {
  constructor(props) {
    super(props);
    let rightSymbol;
    try {
      const [firstParts = {}] = getCurrencyParts();
      rightSymbol = firstParts.$ !== 'symbol';
    } catch (e) {
      rightSymbol = false;
    }
    this.state = {
      rightSymbol,
    };
  }

  componentDidMount() {
    const row = document.getElementById('offerAccordion-row1');
    if (row) {
      row.click();
    }
  }

  createMarkup(content) {
    return {
      __html: content,
    };
  }

  handleClick() {
    trackLinkClick(LINK_NAME.VOUCHER);
  }

  getAmountDisplayValue = ({ value, currencyCode }) => {
    let amountDisplayValue;
    if (this.state.rightSymbol) {
      amountDisplayValue = `${value}${getCurrencySymbol(currencyCode)}`;
    } else {
      amountDisplayValue = `${getCurrencySymbol(currencyCode)}${value}`;
    }
    return amountDisplayValue;
  };

  render() {
    const {
      offerProgram: {
        clientOfferType,
        businessName,
        subTitle,
        description,
        type,
        value,
        currencyCode,
      },
      success,
    } = this.props;

    const isCustomOffer = clientOfferType && clientOfferType === 'CUSTOM';
    const offerTextAmount = formatOfferTextAmount(value, currencyCode, type);
    const titleMessage = isCustomOffer
      ? sanitize(subTitle)
      : messages.offer.title.replace('{amountText}', offerTextAmount);
    const aMessageFrom = messages.offer.messagefrombusiness.replace(
      '{businessName}',
      sanitize(businessName)
    );
    // const additonalMessage = messages.offer.receive.replace('{amountText}', offerTextAmountOff);

    if (titleMessage && description) {
      let heading = (
        <div className={`${css(styles.offerHeader)}`}>
          <div>
            <Icon
              name="gift"
              as="i"
              size="sm"
              style={{ color: '#0070BA', marginRight: 10 }}
            />
          </div>
          <CaptionText
            style={{ margin: 0 }}
            dangerouslySetInnerHTML={this.createMarkup(titleMessage)}
          ></CaptionText>
        </div>
      );
      return (
        <div
          className={` ${css(styles.offerWrapper, success && styles.success)}`}
        >
          <div
            className={`ppvx_row ppvx_d-flex ppvx_justify-content-center ${css(
              styles.accordionWrapper
            )}`}
            onClick={() => this.handleClick()}
          >
            <Accordion name="offerAccordion" className="accordion-no-border">
              <AccordionRow heading={heading}>
                <Divider className={css(styles.offerDivider)} />
                <div className="accordion-body">
                  <p
                    className={css(styles.messageFrom)}
                    dangerouslySetInnerHTML={this.createMarkup(aMessageFrom)}
                  ></p>
                  <p
                    className={css(styles.description)}
                  >{`"${description}"`}</p>
                </div>
              </AccordionRow>
            </Accordion>
          </div>
        </div>
      );
    }
    return null;
  }
}

OfferDetail.propTypes = {
  offerProgram: PropTypes.object.isRequired,
  success: PropTypes.bool,
};

export default OfferDetail;
